import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Card, Button } from 'react-bootstrap';
import './ListaDeSaldos.css';
import DetalleSaldoModal from './DetalleSaldoModal';

const ListaDeSaldos = () => {
  const [saldos, setSaldos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [detalleSaldo, setDetalleSaldo] = useState(null);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCaja, setTotalCaja] = useState(0);
  const [totalVenta, setTotalVenta] = useState(0);
  const [totalRetiro, setTotalRetiro] = useState(0);

  const itemsPerPage = 10;

  useEffect(() => {
    fetchSaldos(currentPage);
   
  }, [currentPage]);
  useEffect(() => {
    fetchTotalCaja()
    fetchTotalVenta()
    fetchTotalRetiro()
  },[])
  //fetchSaldos
  const fetchSaldos = async (page) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/public/v1/Shops/List/PayCredit`,
     
        {
          headers: {
            'Content-Type': 'application/json',
            'SERVICIOS-URBANOS-TOKEN': localStorage.getItem('token'),
            'page': page,
            'itemsPerPage': itemsPerPage
          }
        }
      );
      console.log('Respuesta de la API:', response.data);
      if (response.data && response.data.lista) {
        setSaldos(response.data.lista);
        setTotalPages(response.data.totalPage || 1);
      } else {
        setError('No se encontraron saldos.');
      }
    } catch (error) {
      console.error('error al obtener los saldos:', error.response);
      setError( error.response.data.msg || 'Error al obtener los saldos.');
    }
  };

  const fetchDetalleSaldo = async (id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/public/v1/Shops/List/OneMov`,
        { _id: id },  // id que viene desde metadata
        {
          headers: {
            'Content-Type': 'application/json',
            'SERVICIOS-URBANOS-TOKEN': localStorage.getItem('token')
          }
        }
      );
      if (response.data && response.data.lista) {
        setDetalleSaldo(response.data.lista);
        setShowModal(true);
      } else {
        setError('No se encontró el detalle del saldo.');
      }
    } catch (error) {
      setError(error.response.data.msg || 'Error al obtener el detalle del saldo.');
    }
  };
  
 const fetchTotalCaja =async()=>{
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/public/v1/Shops/totalCaja`,
      {
        headers: {
          'Content-Type': 'application/json',
          'SERVICIOS-URBANOS-TOKEN': localStorage.getItem('token')
        }
      }
    );
    if (response.data  && response.status ===200) {
     setTotalCaja(response.data?.data);
    } else {
      console.log('No se puedo obtenr el total de caja.');
    }
  } catch (error) {
    console.log('No se puedo obtenr el total de caja.');
  }
 }
  const fetchTotalVenta =async()=>{
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/public/v1/Shops/totalVenta`,
        {
          headers: {
            'Content-Type': 'application/json',
            'SERVICIOS-URBANOS-TOKEN': localStorage.getItem('token')
          }
        }
      );
      if (response.data  && response.status ===200) {
       setTotalVenta(response.data?.data);
      } else {
        console.log('No se puedo obtenr el total de venta.');
      }
    } catch (error) {
      console.log('No se puedo obtenr el total de venta.');
    }

 }

 const fetchTotalRetiro =async()=>{
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_URL}/public/v1/Shops/totalRetiro`,
      {
        headers: {
          'Content-Type': 'application/json',
          'SERVICIOS-URBANOS-TOKEN': localStorage.getItem('token')
        }
      }
    );
    if (response.data  && response.status ===200) {
     setTotalRetiro(response.data?.data);
    } else {
      console.log('No se puedo obtenr el total de retiro.');
    }
  } catch (error) {
    console.log('No se puedo obtenr el total de retiro.');
  }

}

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); 
    const year = String(date.getUTCFullYear()).slice(-2); 
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className="lista-saldos-container">
      <Card className="lista-saldos-card">
        <Card.Body>
          <h2 className="lista-saldos-header">Lista de movimientos</h2>
          {error && <p className="text-danger">{error}</p>}
         <Totales totalCaja={totalCaja} totalRetiro={totalRetiro} totalVenta={totalVenta}/>
          <Table striped bordered hover className="lista-saldos-table">
            <thead>
              <tr>
               
                <th>ID de movimiento</th> 
                <th>Fecha</th>
                <th>Monto</th>
                <th>Tipo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {saldos.length>0 ? saldos.map((saldo, index) => (
                <tr key={saldo._id}>
                 
                  <td>{saldo.metadata._id || '-'}</td> 
                  <td>{formatDate(saldo.timestamp)}</td>
                  <td>${saldo.movimiento.balance?.toFixed(2) || 'N/A'}</td>
                  <td>{saldo.movimiento.types}</td>
                  <td>
                  <a href="#" className="link-ver-mas" onClick={() => fetchDetalleSaldo(saldo.metadata._id)}>
                    Ver Más
                     </a>

                  </td>
                </tr>
              )):saldos.length == 0 && (
                <tr>
                  <td></td>
                  <td></td>
                  <td>Sin movimientos</td>
                 
                  <td></td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="lista-saldos-buttons">
            <Button
              variant="secondary"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              Anterior
            </Button>
            <Button
              variant="secondary"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Siguiente
            </Button>
          </div>
        </Card.Body>
      </Card>

      {detalleSaldo && (
        <DetalleSaldoModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          detalleSaldo={detalleSaldo}
        />
      )}
    </div>
  );
};


const Totales =({totalCaja,totalRetiro,totalVenta})=>{
return(

  <div className="container">
  <div className="row text-center">
    <div className="col-md-4 mb-3">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Total en Caja</h5>
          <p className="card-text fs-5">$ {totalCaja}</p>
        </div>
      </div>
    </div>

    <div className="col-md-4 mb-3">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Total en Venta</h5>
          <p className="card-text fs-5">$ {totalVenta}</p>
        </div>
      </div>
    </div>

    <div className="col-md-4 mb-3">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Total en Retiro de dinero</h5>
          <p className="card-text fs-5">$ {totalRetiro}</p>
        </div>
      </div>
    </div>
  </div>
</div>

)
}
export default ListaDeSaldos;
